<template>
  <div>
    <el-tabs v-model="activeName" type="card">
      <!-- 基础通信Topic -->
      <el-tab-pane label="基础通信Topic" name="basic">
        <el-table
          :data="basicTableData"
          :span-method="objectSpanMethod"
          :header-cell-style="{background:'#eef1f6',color:'#606266'}"
          border
          style="width: 100%; margin-top: 20px">
          <el-table-column
            prop="functionName"
            label="功能"
            width="180">
          </el-table-column>
          <el-table-column
            prop="topicClass"
            label="Topic类">
          </el-table-column>
          <el-table-column
            prop="operateAuth"
            label="操作权限">
          </el-table-column>
          <el-table-column
            prop="description"
            label="描述">
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <!-- 物模型通信Topic -->
      <el-tab-pane label="物模型通信Topic" name="physicalModel">
        <el-table
          :header-cell-style="{background:'#eef1f6',color:'#606266'}"
          :data="physicalModelTableData"
          :span-method="objectSpanMethod"
          border
          style="width: 100%; margin-top: 20px">
          <el-table-column
            prop="functionName"
            label="功能"
            width="180">
          </el-table-column>
          <el-table-column
            prop="topicClass"
            label="Topic类">
          </el-table-column>
          <el-table-column
            prop="operateAuth"
            label="操作权限">
          </el-table-column>
          <el-table-column
            prop="description"
            label="描述">
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <!-- 自定义Topic -->
      <el-tab-pane label="自定义topic" name="custom">
        <el-button type="primary" @click="addTopic" class="add-topic" :disabled="proStatus">定义topic类</el-button>
        <!-- table -->
        <el-table
          :data="customTableData"
          :header-cell-style="{background:'#eef1f6',color:'#606266'}"
          style="width: 100%">
          <el-table-column
            prop="topicClass"
            label="自定义Topic"
            >
          </el-table-column>
          <el-table-column
            prop="operateAuth"
            label="操作权限"
            align="center"
            >
          </el-table-column>
          <el-table-column
            prop="description"
            label="描述"
            align="center"
            >
          </el-table-column>
          <el-table-column
            v-if="!proStatus"
            prop="operation"
            label="操作"
            align="center"
            >
            <template slot-scope="scope">
              <!-- <el-button
                size="mini"
                type="primary"
                @click="handleEdit(scope.row)">编辑</el-button> -->
                <el-button
                  size="mini"
                  type="danger"
                  slot="reference"
                  @click="handleDelete(scope.row)">
                   删除
                </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- dialog -->
        <el-dialog title="定义topic类" :close-on-click-modal="false" :visible.sync="dialogFormVisible" width="25%" v-if="dialogFormVisible" :append-to-body="true" :before-close="cancle">
          <div class="infos-wrap">
            <i class="el-icon-info"></i>
            <p class="infos">
            Topic 格式必须以“/”进行分层，区分每个类目。其中前三个类目已经规定好，第一个代表产品标识 productKey，第二个 ${deviceName} 通配 deviceName，第三个 user 用来标识产品的自定义 Topic 类。简单来说，Topic 类：/a15T****dhK/${deviceName}/user/update 是具体 Topic：/a15T****dhK/mydevice1/user/update 和 /a15T****dhK/mydevice2/user/update 等的集合。
            </p>
          </div>
          <el-form :model="ruleForm" ref="ruleForm" :rules="rules">
            <el-form-item label="操作权限"  prop="operateAuth">
              <el-select v-model="ruleForm.operateAuth" placeholder="请选择活动区域" style="width:100%">
                <el-option
                v-for="(item,index) in authorityOption"
                :key="index"
                :label="item.lable"
                :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Topic类" prop="topicClass">
              <br>
              <div>/{{this.sRow.productKey}}/${deviceName}/user/</div>
              <el-input v-model.trim="ruleForm.topicClass" placeholder="请输入您的Topic类名"></el-input>
            </el-form-item>
            <el-form-item label="描述">
              <el-input v-model="ruleForm.description" placeholder="请输入描述" show-word-limit type="textarea" :rows="4"  maxlength="100"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancle">取 消</el-button>
            <el-button type="primary" @click="confirm('ruleForm')">确 定</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
      <!-- 拓补关系 -->
      <el-tab-pane label="拓补关系" name="topol">
        <el-table
          :data="topologyTableData"
          :span-method="objectSpanMethod"
          :header-cell-style="{background:'#eef1f6',color:'#606266'}"
          border
          style="width: 100%; margin-top: 20px">
          <el-table-column
            prop="functionName"
            label="功能"
            width="180">
          </el-table-column>
          <el-table-column
            prop="topicClass"
            label="Topic类">
          </el-table-column>
          <el-table-column
            prop="operateAuth"
            label="操作权限">
          </el-table-column>
          <el-table-column
            prop="description"
            label="描述">
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { topicList, addTopic, deleteTopic } from '@/api/productRegistration'
import { mapGetters } from 'vuex'
export default {
  data () {
    const validatePass = function (rule, value, callback) {
      const reg = /^[0-9a-zA-Z_/]{1,64}$/
      if (!reg.test(value)) {
        callback(new Error('Topic 类名用/分割，支持英文字母、数字、下划线，长度限制 64'))
      } else {
        callback()
      }
    }
    return {
      sRow: null,
      activeName: 'basic',
      basicTableData: [],
      physicalModelTableData: [],
      customTableData: [],
      topologyTableData: [],
      physicalModelObj: null,
      basicObj: null,
      topologyObj: null,
      spanArr: [], // 用于存放每一行记录的合并数
      spanArr2: [],
      spanArr3: [],
      dialogFormVisible: false, // dialog开关
      authorityOption: [
        {
          label: 1,
          // value: '发布'
          value: '订阅'
        },
        {
          label: 2,
          // value: '订阅'
          value: '发布'
        },
        {
          label: 3,
          value: '发布和订阅'
        }
      ],
      ruleForm: {
        operateAuth: '',
        topicClass: '',
        description: ''
      },
      rules: {
        operateAuth: [
          { required: true, message: '请选择设备操作权限', trigger: 'change' }
        ],
        topicClass: [
          { required: true, message: '请输入Topic类', trigger: 'change' },
          { validator: validatePass, trigger: 'change' }
        ]
      },
      topicInfoId: ''
    }
  },
  computed: {
    ...mapGetters(['proStatus'])
  },
  created () {
    if (localStorage.getItem('infos')) {
      this.sRow = JSON.parse(localStorage.getItem('infos'))
    } else {
      this.sRow = JSON.parse(this.$route.query.sRow)
    }
  },
  mounted () {
    this.getTopicList()
  },
  methods: {
    cancle () {
      this.dialogFormVisible = false
      this.ruleForm.operateAuth = ''
      this.ruleForm.topicClass = ''
      this.ruleForm.description = ''
    },
    // 获取对应标
    getSpanArr (data, val) {
      if (val === 'basic') {
        // data就是我们从后台拿到的数据
        for (var i = 0; i < data.length; i++) {
          if (i === 0) {
            this.spanArr.push(1)
            this.pos = 0
          } else {
          // 判断当前元素与上一个元素是否相同
            if (data[i].functionName === data[i - 1].functionName) {
              this.spanArr[this.pos] += 1
              this.spanArr.push(0)
            } else {
              this.spanArr.push(1)
              this.pos = i
            }
          }
        }
      }
      if (val === 'physicalModel') {
        for (var j = 0; j < data.length; j++) {
          if (j === 0) {
            this.spanArr2.push(1)
            this.pos1 = 0
          } else {
          // 判断当前元素与上一个元素是否相同
            if (data[j].functionName === data[j - 1].functionName) {
              this.spanArr2[this.pos1] += 1
              this.spanArr2.push(0)
            } else {
              this.spanArr2.push(1)
              this.pos1 = j
            }
          }
        }
      }
      if (val === 'topol') {
        for (var k = 0; k < data.length; k++) {
          if (k === 0) {
            this.spanArr3.push(1)
            this.pos2 = 0
          } else {
          // 判断当前元素与上一个元素是否相同
            if (data[k].functionName === data[k - 1].functionName) {
              this.spanArr3[this.pos2] += 1
              this.spanArr3.push(0)
            } else {
              this.spanArr3.push(1)
              this.pos2 = k
            }
          }
        }
      }
    },
    getTopicList () {
      const params = {
        empty: true,
        params: {
          productKey: this.sRow.productKey
        }
      }
      topicList(params).then(res => {
        console.log(res.data.data)
        this.basicObj = res.data.data[1]
        this.physicalModelObj = res.data.data[2]
        this.customObj = res.data.data[3]
        this.topologyObj = res.data.data[4]
        this.formatArrData(this.basicObj, 'basic')
        this.formatArrData(this.physicalModelObj, 'physicalModel')
        this.formatArrData(this.topologyObj, 'topol')
        this.getSpanArr(this.basicTableData, 'basic')
        this.getSpanArr(this.physicalModelTableData, 'physicalModel')
        this.getSpanArr(this.topologyTableData, 'topol')
        // 自定义topic
        Object.keys(this.customObj).forEach(key => {
          this.customObj[key].forEach(ele => {
            ele.operateAuth = ele.operateAuth === 1 ? '订阅' : ele.operateAuth === 2 ? '发布' : '发布和订阅'
            ele.description = ele.description === '' || typeof (ele.description) === 'object' ? '---' : ele.description
          })
          this.customTableData = this.customObj[key]
        })
      })
    },
    // 数据格式化
    formatArrData (data, val) {
      if (data) {
        console.log(data)
        Object.keys(data).forEach(key => {
          data[key].forEach(ele => {
            const item = {
              topicInfoId: ele.topicInfoId,
              functionName: ele.functionName,
              topicClass: ele.topicClass,
              operateAuth: ele.operateAuth === 1 ? '订阅' : '发布',
              description: ele.description === '' || typeof (ele.description) === 'object' ? '---' : ele.description
            }
            val === 'basic' ? this.basicTableData.push(item) : val === 'physicalModel' ? this.physicalModelTableData.push(item) : this.topologyTableData.push(item)
          })
        })
      }
    },
    // 合并行
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (this.activeName === 'basic') {
          const _row = this.spanArr[rowIndex]
          const _col = _row > 0 ? 1 : 0
          // console.log(`rowspan:${_row} colspan:${_col}`)
          return {
          // [0,0] 表示这一行不显示， [2,1]表示行的合并数
            rowspan: _row,
            colspan: _col
          }
        }
        if (this.activeName === 'physicalModel') {
          const _row = this.spanArr2[rowIndex]
          const _col = _row > 0 ? 1 : 0
          // console.log(`rowspan:${_row} colspan:${_col}`)
          return {
          // [0,0] 表示这一行不显示， [2,1]表示行的合并数
            rowspan: _row,
            colspan: _col
          }
        }
        if (this.activeName === 'topol') {
          const _row = this.spanArr3[rowIndex]
          const _col = _row > 0 ? 1 : 0
          // console.log(`rowspan:${_row} colspan:${_col}`)
          return {
          // [0,0] 表示这一行不显示， [2,1]表示行的合并数
            rowspan: _row,
            colspan: _col
          }
        }
      }
    },
    addTopic () {
      this.dialogFormVisible = true
    },
    /* handleEdit (sRow) {
      const topic = sRow.topicClass.slice(sRow.topicClass.indexOf('user/') + 5)
      this.ruleForm.topicClass = topic
      this.topicInfoId = sRow.topicInfoId
      this.dialogFormVisible = true
    }, */
    handleDelete (sRow) {
      const params = {
        params: {
          productKey: sRow.productKey,
          topicInfoId: sRow.topicInfoId
        }
      }
      this.$confirm(`确认删除【${sRow.topicClass}】topic吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteTopic(params).then(
          res => {
            if (res.data.code === 200) {
              this.$message.success('删除成功')
            }
            setTimeout(() => {
              window.location.reload()
            }, 500)
          }
        )
      })
    },
    confirm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const topic = '/' + this.sRow.productKey + '/' + '$' + '{' + 'deviceName' + '}' + '/user/'
          const params = {
            params: {
              operateAuth: this.ruleForm.operateAuth === '订阅' ? 1 : this.ruleForm.operateAuth === '发布' ? '2' : '3',
              topicClass: topic + this.ruleForm.topicClass,
              description: this.ruleForm.description,
              topicType: 3,
              productKey: this.sRow.productKey
            }
          }
          /* if (this.topicInfoId !== '') {   编辑功能暂时不做
            params.params.topicInfoId = this.topicInfoId
          } */
          addTopic(params).then(res => {
            if (res.data.code === 200) {
              this.$message({
                type: 'success',
                message: '自定义Topic成功'
              })
              this.$nextTick(() => {
                // this.getTopicList()
                setTimeout(() => {
                  window.location.reload()
                }, 500)
              })
              this.dialogFormVisible = false
            }
          })
        } else {
          this.$message.error('请完善信息后再试')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .add-topic{
    margin-bottom: 20px !important;
  }
  /deep/ .el-tab-pane{
    border: none;
  }
  .infos-wrap{
    margin-bottom: 16px;
    background-color: #e5f3ff;
    box-sizing: border-box;
    padding: 8px 12px 8px 16px;
    display: flex;
    .el-icon-info{
      margin-top: 3px;
      margin-right: 10px;
      color: #0070cc;
    }
  }
</style>
